import React from "react";
import Ammenties from '../ammenties/Ammenties'
const AmmentiesPage = () => {
  return (
    <div>
      <Ammenties />
    </div>
  );
};

export default AmmentiesPage;
